import React from 'react';
import { getFieldSetting } from '../helpers/HelperFunctions.js';

const PinIcon = () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#9A9A9A" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 21c4.5-4.2 7-7.4 7-11a7 7 0 10-14 0c0 3.6 2.5 6.8 7 11z" />
        <circle cx="12" cy="10" r="2.5" />
    </svg>
);
const SwapIcon = () => (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#5C5C5C" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M17 4v14M17 18l-3-3M17 18l3-3M7 20V6M7 6L4 9M7 6l3 3" />
    </svg>
);

// Маршрут: два текстових поля документа, імена яких вказані в Settings. Кнопка праворуч
// міняє місцями введені значення.
const RouteInput = (props) => {
    const { name, value, settings, disabled } = props;

    const fromFieldName = getFieldSetting(settings, 'FromField');
    const toFieldName = getFieldSetting(settings, 'ToField');

    const from = value?.[fromFieldName] ?? '';
    const to = value?.[toFieldName] ?? '';

    const changeHandle = (newFrom, newTo) => {
        if (!props.onChange) return;
        const newValue = { ...value };
        if (fromFieldName) newValue[fromFieldName] = newFrom;
        if (toFieldName) newValue[toFieldName] = newTo;
        props.onChange({ target: { name: name, value: newValue } });
    }

    return (<div className={'route-input' + (disabled ? ' disabled' : '')} id={name} name={name} >
        <div className="route-input-points">
            <div className="route-input-point">
                <PinIcon />
                <input name={fromFieldName} value={from} placeholder={getFieldSetting(settings, 'FromFieldLabel')}
                    disabled={disabled ? "disabled" : ""} onChange={(e) => changeHandle(e.target.value, to)} />
            </div>
            <div className="route-input-divider" />
            <div className="route-input-point">
                <PinIcon />
                <input name={toFieldName} value={to} placeholder={getFieldSetting(settings, 'ToFieldLabel')}
                    disabled={disabled ? "disabled" : ""} onChange={(e) => changeHandle(from, e.target.value)} />
            </div>
        </div>
        {!disabled && <button type="button" className="route-input-swap" onClick={() => changeHandle(to, from)}>
            <SwapIcon />
        </button>}
    </div>);
}

export default RouteInput;
